import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import * as S from './RuleHighlight.styles';

/**
 * Rule callout for how-to-play pages (orange left-border highlight).
 *
 * Props:
 *  - title?: string
 *  - text: string
 */
const RuleHighlight = ({ title, text }) => {
  return (
    <S.Callout>
      <FaInfoCircle />
      <div>
        {title && <S.CalloutTitle>{title}</S.CalloutTitle>}
        {text && <S.CalloutText>{text}</S.CalloutText>}
      </div>
    </S.Callout>
  );
};

export default RuleHighlight;
